document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".product-finder-wrapper");
  if (!wrapper) return;

  const screens = Array.from(wrapper.querySelectorAll(".screen-wrap"));
  const breadcrumbSpans = Array.from(
    wrapper.querySelectorAll(".breadcrumb li .step span")
  );

  function scrollToWrapper() {
    const top =
      wrapper.getBoundingClientRect().top +
      (window.pageYOffset || document.documentElement.scrollTop);
    window.scrollTo({ top, behavior: "smooth" });
  }

  function getSelectedValue(screenEl) {
    const li = screenEl?.querySelector(".option-wrap li.active");
    return li ? (li.getAttribute("data-value") || "").trim() : "";
  }

  function togglePregnancyOption() {
    const activityScreen = screens[2];
    if (!activityScreen) return;

    const pregnancyLi = activityScreen.querySelector(
      '.option-wrap li[data-value="pregnancy-post-partum"]'
    );
    if (!pregnancyLi) return;

    const gender = getSelectedValue(screens[1]);

    if (gender === "male") {
      const wasActive = pregnancyLi.classList.contains("active");
      pregnancyLi.classList.remove("active");
      pregnancyLi.style.display = "none";

      if (wasActive) {
        const nextBtn = activityScreen.querySelector(".btn--primary");
        if (nextBtn) nextBtn.classList.add("disabled");
      }
    } else {
      pregnancyLi.style.display = "";
    }
  }

  breadcrumbSpans.forEach((span) => {
    span.dataset.default = span.textContent || "";
  });
  function updateGenderImageMode() {
    const gender = getSelectedValue(screens[1]);

    wrapper.classList.remove("is-male", "is-female");

    if (gender === "male") {
      wrapper.classList.add("is-male");
    } else if (gender === "female") {
      wrapper.classList.add("is-female");
    }
  }

  function resetFinder() {
    screens.forEach((screen, idx) => {
      screen.classList.remove("active");
      screen.style.display = idx === 0 ? "block" : "none";
      if (idx === 0) screen.classList.add("active");
    });

    wrapper.querySelectorAll(".option-wrap li.active").forEach((li) => {
      li.classList.remove("active");
    });

    const allPrimaryBtns = Array.from(
      wrapper.querySelectorAll(".screen-wrap .btn--primary")
    );
    allPrimaryBtns.forEach((btn, idx) => {
      if (idx === 0) btn.classList.remove("disabled");
      else btn.classList.add("disabled");
    });

    breadcrumbSpans.forEach((span) => {
      span.textContent = span.dataset.default || "";
    });

    togglePregnancyOption();
    updateGenderImageMode();
  }

  function reinitThemeProductForms(container) {
    if (!container) return;

    try {
      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
    } catch (_) {}
    container.querySelectorAll(".product-card__atc").forEach((btn) => {
      btn.classList.remove("disabled");
      btn.disabled = false;
    });
    container.querySelectorAll("form").forEach((form) => {
      form.removeAttribute("data-initialized");
    });
  }

  async function ajaxAddToCart(variantId, quantity = 1) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || "Add to cart failed");
    }
    return res.json();
  }

  function openCartOrRefresh() {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true })
    );
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }

  wrapper.addEventListener("submit", async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    const inFinderResults = form.closest("#pf-results");
    if (!inFinderResults) return;

    const idInput =
      form.querySelector('input[name="id"]') ||
      form.querySelector('select[name="id"]');

    if (!idInput) return;

    const variantId =
      idInput instanceof HTMLSelectElement ? idInput.value : idInput.value;

    if (!variantId) return;

    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    try {
      await ajaxAddToCart(variantId, 1);
      openCartOrRefresh();
    } catch (err) {
      console.error(err);
      alert("Could not add to cart. Please try again.");
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });

  resetFinder();

  wrapper.addEventListener("click", (e) => {
    const li = e.target.closest(".option-wrap li");
    if (!li) return;

    const wrap = li.closest(".option-wrap");
    const screen = li.closest(".screen-wrap");
    if (!wrap || !screen) return;

    wrap.querySelectorAll("li.active").forEach((sib) =>
      sib.classList.remove("active")
    );
    li.classList.add("active");

    const btn = screen.querySelector(".btn--primary");
    if (btn) btn.classList.remove("disabled");

    const screenIndex = screens.indexOf(screen) - 1;
    if (screenIndex >= 0 && breadcrumbSpans[screenIndex]) {
      const titleEl = li.querySelector(".title");
      const selectedText = titleEl ? titleEl.textContent.trim() : "";
      breadcrumbSpans[screenIndex].textContent = `(${selectedText})`;
    }

    if (screen === screens[1]) {
      togglePregnancyOption();
      updateGenderImageMode();
    }
  });

  function showResultsByRuleMatch() {
    const gender = getSelectedValue(screens[1]);
    const activity = getSelectedValue(screens[2]);
    const duration = getSelectedValue(screens[3]);

    console.log("Selected values:", { gender, activity, duration });

    const panels = Array.from(wrapper.querySelectorAll(".pf-products-panel"));
    panels.forEach((p) => {
      p.style.display = "none";
    });

    const empty = wrapper.querySelector(".pf-products-empty");
    if (empty) empty.style.display = "none";

    let matchedPanel = null;

    panels.forEach((p, index) => {
      const pDuration = (p.dataset.duration || "").trim();

      const allowedGenders = (p.dataset.genders || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);

      const allowedActs = (p.dataset.activities || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);

      const productHandles = (p.dataset.productHandles || "").trim();
      const title = (p.dataset.title || "").trim();

      console.log(`Panel ${index + 1}`, {
        title,
        duration: pDuration,
        genders: allowedGenders,
        activities: allowedActs,
        productHandles
      });

      const isMatch =
        pDuration === duration &&
        allowedGenders.includes(gender) &&
        allowedActs.includes(activity);

      if (isMatch && !matchedPanel) {
        matchedPanel = p;
        console.log("Matched panel found:", {
          panelIndex: index + 1,
          title,
          duration: pDuration,
          genders: allowedGenders,
          activities: allowedActs,
          productHandles
        });
        console.log(
          "Rendered product cards count:",
          p.querySelectorAll(".product-card-li").length
        );
      }
    });

    if (matchedPanel) {
      matchedPanel.style.display = "block";
    } else if (empty) {
      console.warn("No matching panel found for selection:", {
        gender,
        activity,
        duration
      });
      empty.style.display = "block";
    }

    const results = wrapper.querySelector("#pf-results");
    reinitThemeProductForms(results);
  }

  wrapper.addEventListener("click", (e) => {
    const startAgain = e.target.closest(".breadcrumb .start");
    if (startAgain) {
      resetFinder();
      return;
    }

    const btn = e.target.closest(".btn--primary");
    if (!btn) return;

    // 🚫 Ignore product card buttons (Add to Cart)
    if (btn.closest("#pf-results")) {
      // Let Shopify handle it OR submit handler handle it
      return;
    }

    e.preventDefault();
    if (btn.classList.contains("disabled")) return;

    const current = btn.closest(".screen-wrap");
    if (!current) return;

    const currentIndex = screens.indexOf(current);
    const next = screens[currentIndex + 1];
    if (!next) return;

    current.classList.remove("active");
    current.style.display = "none";

    next.classList.add("active");
    next.style.display = "block";

    if (currentIndex === 3) {
      showResultsByRuleMatch();
    }

    scrollToWrapper();
  });
});